import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";

const AboutUsPage = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        textAlign: "center",
        marginBottom: isMobile ? 10 : 59,
      }}
    >
      {/* Image */}
      <img
        src="about.png"
        alt="About Us"
        style={{
          width: "100%",
          height: "auto",
          marginBottom: "20px",
        }}
      />

      {/* Box containing the text */}
      <Box
        sx={{
          position: isMobile ? "relative" : "absolute",
          top: isMobile ? "auto" : "70%",
          left: isMobile ? "auto" : "50%",
          transform: isMobile ? "none" : "translateX(-50%)",
          width: "80%",
          textAlign: "center",
          paddingTop: 5,
          backgroundColor: "#fff",
          margin: isMobile ? "0 auto" : "0",
        }}
      >
        {/* Updated Paragraph with larger text */}
        <Typography
          variant="body1"
          color="#5595DB"
          sx={{
            textAlign: "left",
            width: isMobile ? "100%" : "65%",
            margin: "0 auto",
            fontSize: "1.2rem", // Increased font size
            mb: 5,
          }}
        >
          At Banner Day Threads, our story is built on nearly 30 years of headwear expertise and a legacy of innovation.
          Our founders and design team bring decades of hands-on experience in the industry,
          having mastered the art and science of crafting premium headwear.
        </Typography>

        {/* Centered Header now in black */}
        <Typography
          variant="h5"
          color="#000"
          sx={{
            textAlign: "center",
            width: "100%",
            fontWeight: "bold",
            mb: 5,
          }}
        >
          Every Day is Saturday
        </Typography>

        {/* Changed text to black */}
        <Typography
          color="#000"
          sx={{
            textAlign: "left",
            width: isMobile ? "100%" : "65%",
            margin: "0 auto",
            mb: 5,
          }}
        >
          We believe every day should feel like a Saturday - relaxed, vibrant, and full of possibility.
          Whether you’re representing a corporate brand or launching a retail empire, 
          our mission is to create custom hats that put your brand in the spotlight, not ours. 
          With a team that understands the nuances of headwear, corporate sponsorships, and cutting-edge marketing, 
          we’ve revolutionized the process of designing premium custom hats. 
          After years working behind the scenes for the biggest names in the industry, 
          we identified an opportunity to streamline and modernize the art of headwear creation - making it more accessible, seamless, and fast.
        </Typography>

        <Typography
          color="#000"
          sx={{
            textAlign: "left",
            width: isMobile ? "100%" : "65%",
            margin: "0 auto",
          }}
        >
          With low minimums, rapid turnarounds, and an unwavering commitment to quality craftsmanship, 
          we redefine what’s possible in custom headwear. Every hat is a bespoke reflection of your brand, 
          crafted with premium materials, precise detailing, and the highest level of customization. 
          Let’s create something extraordinary together - get the best custom hats to showcase your brand, 
          and then sit back, relax, and enjoy a Saturday…every day of the week.
        </Typography>
      </Box>
    </Box>
  );
};

export default AboutUsPage;
